import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppExternalLink } from 'shared/UI/UIKit/Link';
import { AppText } from 'shared/UI/UIKit/Text';
import { AppDivider } from 'shared/UI/UIKit/Divider';
import { useProfileRole } from 'common/use-profile-role';
import { AppSchoolIcon } from 'shared/UI/UIKit/icons/School';
import styles from './Menu.module.scss';

export const AppHeaderMenu = () => {
  const { profile, isManager } = useProfileRole();
  const organizationName = profile?.organization?.name;

  return (
    <AppFlex unit="16" direction="row" className={styles.links} alignItems="center">
      {isManager && organizationName && (
        <>
          <AppFlex>
            <AppText
              size={16}
              weight={500}
              className={styles['organization-name']}
              title={organizationName}
            >
              {organizationName}
            </AppText>
          </AppFlex>
          <AppDivider vertical className={styles.divider} width="100" />
        </>
      )}
      <AppFlex alignItems="center" justifyContent="center">
        <AppExternalLink
          target="_blank"
          className={styles['app-link-control']}
          href="https://www.edsoo.ru/"
        >
          <AppSchoolIcon />
        </AppExternalLink>
      </AppFlex>
    </AppFlex>
  );
};
